import { apiRequest } from "util/services";

// Sonic Survey → Settings → Agent knowledge base: ready answers and topic guidelines every
// voice survey of the company shares. With instrumentId the response also carries that
// survey's own records and the company records it switched off (off_ids).
export const fetchAgentKnowledge = (instrumentId) =>
  apiRequest(
    instrumentId ? `feedback/agent-knowledge?instrument_id=${encodeURIComponent(instrumentId)}` : "feedback/agent-knowledge",
    "GET",
    null,
    true
  );

// record: { kind: "answer" | "guideline", topic, trigger, response, after_action: "continue" | "end_call",
// active }. instrument_id makes it that survey's own record.
export const createAgentKnowledge = (record) => apiRequest("feedback/agent-knowledge", "POST", record, true);

export const updateAgentKnowledge = (id, changes) => apiRequest(`feedback/agent-knowledge/${id}`, "PUT", changes, true);

export const deleteAgentKnowledge = (id) => apiRequest(`feedback/agent-knowledge/${id}`, "DELETE", null, true);

// Switches a company record off (or back on) for one survey.
export const setAgentKnowledgeOff = (id, instrumentId, off) =>
  apiRequest(`feedback/agent-knowledge/${id}/surveys/${instrumentId}`, "PUT", { off }, true);

// The company's default disclosure, used by voice surveys that have none of their own.
export const saveAgentKnowledgeSettings = (disclosure) =>
  apiRequest("feedback/agent-knowledge/settings", "PUT", { disclosure }, true);
